import React from 'react';
import { 
  compose
, withPropsOnChange
, withStateHandlers
, withState
, withProps
} from 'recompose';
import { isFunction, find } from 'lodash';
import { LocalForm, Control, actions, Errors } from 'react-redux-form';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import {
  FormGroup,
  required,
  SaveButton,
  DatePicker,
} from 'components/common/Forms';
import { withForm, withDebug, withResolver } from 'components/common';
import { NotificationManager } from 'react-notifications';
import { Button, Row, Col } from 'reactstrap';
import Select from 'react-select';
import moment from 'moment';
import _ from 'lodash';
import shortid from 'shortid';

export const ChangeStatus = ({
  onChange,
  onUpdate,
  item,
  client,
  job,
  refresh,
  setRefresh,
  form,
  setDispatch,
  dispatch,
  onSubmit,
  onCancel,
  statuses,
  rejectionReasons,
}) => (
  <LocalForm
    component="div"
    onSubmit={onSubmit}
    getDispatch={setDispatch}
    onChange={onChange}
    onUpdate={onUpdate}
    initialState={item}
    validators={{
      job_status: { required },
      appointment_date: {
        past: v => (v ? moment(v) > moment() : true),
      },
    }}
  >
    <FormGroup model=".job_status" label="Job Status" addControlClass={false}>
      <Control.select
        className="placeholder-black"
        model=".job_status"
        component={Select}
        options={statuses}
        changeAction={(model, value) => {
          dispatch(actions.change(model, value ? value.value : null));
          dispatch(
            actions.change('local.status_text', value ? value.text : '')
          );
        }}
        labelKey="text"
        valueKey="value"
        placeholder={item.status_text}
        clearable={false}
      />
    </FormGroup>
    {statuses &&
      parseInt(item.job_status, 10) ===
        find(statuses, e => e.text === 'Installation Booked').value && (
        <div>
          <Row>
            <Col>
              {(job.preferred_install_date_1 ||
                job.preferred_install_date_2 ||
                job.preferred_install_date_3) && (
                <div>
                  <h4>Preferred Dates</h4>
                  <ol>
                    {job.preferred_install_date_1 && (
                      <li>{job.preferred_install_date_1}</li>
                    )}
                    {job.preferred_install_date_2 && (
                      <li>{job.preferred_install_date_2}</li>
                    )}
                    {job.preferred_install_date_3 && (
                      <li>{job.preferred_install_date_3}</li>
                    )}
                  </ol>
                </div>
              )}
            </Col>
          </Row>
      </div>
      )}
    <div className="clearfix">
      <Button type="button" onClick={onCancel} outline className="float-left">
        Cancel
      </Button>
      {item.job_status !== 40 &&
        <SaveButton
          onClick={() => dispatch(actions.submit('local'))}
          form={form}
          className="float-right"
        >
          Update
        </SaveButton>
      }
    </div>
  </LocalForm>
);

export const enhance = compose(
  withDebug('item'),
  withState('isCalendarOpen','setIsCalendarOpen',false),
  withProps( props => ({
    toggleCalendarModal : () => props.setIsCalendarOpen(!props.isCalendarOpen)
  })),
  withStateHandlers(
    {},
    {
      setStatuses: () => statuses => ({ statuses }),
    }
  ),
  withResolver(
    {
      jobStatuses: () => client => client.get('job_statuses_by_type?filter=all'),
      jobStatusesAll: () => client => client.get('job_statuses'),
    },
    {
      onResolved: ({ setStatuses, job }) => ({ jobStatuses, jobStatusesAll }) => {
        var statuses = _.get(_.find(jobStatuses, (obj) => obj.type.text == job.order_job_type), 'statuses');
        if(statuses && statuses.length != 0) {
          setStatuses(statuses);
        } else {
          setStatuses(jobStatusesAll);
        }
      },
    }
  ),
  withForm({
    defaultItem: ({ status, statusText, rejection, rejectionText}) => ({
      job_status: status,
      status_text: statusText,
      rejection: rejection,
      rejection_text : rejectionText,
    }),
    onSubmit: ({
      item: {
        job_status,
        status_text,
        rejection_text,
        appointment_date,
        rejection,
      },
      client,
      job,
      onChanged,
    }) => () => {
      client
        .patch(`/installer-jobs/${job.id}`, {
          appointment_date,
          job_status,
          rejection,
        })
        .then(() => {
          NotificationManager.success('Job Status successfully assigned');
          if (isFunction(onChanged)) {
            onChanged({
              job_status,
              rejection,
              status_text,
              rejection_text,
              appointment_date,
            });
          }
        });
    },
  })
);

export default enhance(ChangeStatus);



// WEBPACK FOOTER //
// ./src/pages/Jobs/ChangeStatus.js